import { render } from "./PalliativeCarePlan.vue?vue&type=template&id=04bbac77&scoped=true"
import script from "./PalliativeCarePlan.vue?vue&type=script&lang=js"
export * from "./PalliativeCarePlan.vue?vue&type=script&lang=js"

import "./PalliativeCarePlan.vue?vue&type=style&index=0&id=04bbac77&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bbac77"]])

export default __exports__